const _prefix = 'crysp__'

module.exports = {
  get: (name) => {
    return localStorage.getItem(_prefix + name)
  },

  set: (name, value) => {
    localStorage.setItem(_prefix + name, value)
  }
}